import React from 'react';
import { Image } from 'react-bootstrap';
import { icon } from '../../../../data/photoUrls';
import { useIcon } from '../../../../util/hooks';
import { SquareIconProps } from './SquareIcon';

interface IconProps extends SquareIconProps {}

export const Icon: React.FC<IconProps> = ({ width = 16, height = 16, src }) => {
  const iconValue = useIcon(icon);

  return (
    <Image
      src={src ? src : iconValue}
      width={width}
      height={height}
      alt={'city-element--v1'}
    />
  );
};
